import { render } from "./simpleSms.vue?vue&type=template&id=37f239e3&scoped=true"
import script from "./simpleSms.vue?vue&type=script&lang=js"
export * from "./simpleSms.vue?vue&type=script&lang=js"

import "./simpleSms.vue?vue&type=style&index=0&id=37f239e3&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/cleanshift_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f239e3"]])

export default __exports__